import { Spin } from 'antd'
import styled from 'styled-components'

const StyledIngredientDiscrepancyLoader = styled(Spin)`
  margin-right: 6px;
`

export default StyledIngredientDiscrepancyLoader
